type RgbObject = { r: number; g: number; b: number };

const SHORTHAND_REGEX = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;

export const hexToRgb = (hex?: string): RgbObject | undefined => {
  if (!hex) return undefined;

  // Handles 3 digit hex by doubling
  const longHandHexCode = hex.replace(SHORTHAND_REGEX, (m, r, g, b) => {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(longHandHexCode);

  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : undefined;
};
